export default "__VITE_ASSET__ad9d3ee7__"